import { useState } from 'react';
import SchemaOrg from '@/components/feature/SchemaOrg';

const faqItems = [
  {
    question: '韩漫网上的漫画都是免费的吗？',
    answer: '是的！韩漫网致力于提供完全免费的韩国漫画在线阅读服务。我们收录的热门韩漫、最新韩漫资源均可免费阅读，每日更新，无需付费即可畅享正版韩漫阅读体验。',
  },
  {
    question: '韩漫网的漫画更新频率是怎样的？',
    answer: '韩漫网保持每日更新，每天同步上传最新韩国漫画章节。您可以在"今日新番"板块查看24小时内更新的热门韩漫，确保不错过任何精彩内容。',
  },
  {
    question: '韩漫网支持哪些设备阅读？',
    answer: '韩漫网采用响应式设计，完美适配电脑、平板和手机等各类设备。无论您使用什么设备访问韩漫网，都能获得流畅舒适的漫画阅读体验。',
  },
  {
    question: '如何找到我想看的韩国漫画？',
    answer: '您可以通过韩漫网顶部的分类导航浏览不同题材的漫画，包括恋爱、奇幻、动作、搞笑、悬疑、剧情等多种类型。也可以使用搜索功能直接查找您想看的作品。',
  },
  {
    question: '韩漫网的漫画有版权吗？',
    answer: '韩漫网严格遵守版权法规，所有内容均来自正版授权渠道。我们致力于为读者提供安全、合法的韩国漫画在线阅读环境，让您放心阅读。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-3xl mx-auto">
        <SchemaOrg type="FAQPage" faqItems={faqItems} />

        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-secondary-200 text-secondary-700 rounded-full text-xs font-medium mb-3">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            关于韩漫网
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            解答您对免费韩漫阅读的常见疑问
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-secondary-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="font-heading text-base text-foreground-800 pr-4">
                  {item.question}
                </span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-400"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}